import { environment as env } from './environment.default'

// local demo build for the Paris profile : same neutral (non ACTV) context as
// environment.demolocal, but demoCity = 'paris' so the map, the brand and the datasets
// switch to the Grand Paris / Île-de-France network. Like the Lyon build this one runs in
// FRENCH, which is the authoring language of the app, so nothing has to be translated.
//
// NOTE amounts stay in euros and the UI renders them with '€' : the sign comes from
// CityProfile.currency — see @core/city-profile/currency.util.
const production = false
const mode = 'NEUTRAL'
const context = 'neutral'

// served behind nginx : call the backend same-origin under /api (proxied to gwapi)
const apiEndpoint = '/api'

// selects the demo city profile (map centre, brand, datasets) — see @core/city-profile
const demoCity = 'paris'

// demo runs in French, centred on the Île de la Cité
const lang = 'fr'
const geo = 'fr'
const locale = `${lang}-${geo}`
const tz = 'Europe/Paris'
const timezone = tz

// authentication is REQUIRED at connection (same as the other demo builds)
const demoBypassAuth = false

// auto-login credentials, used ONLY when demoBypassAuth is true (no-op here)
const demoAccount = 'admin'
const demoPassword = 'demoparis2026'

export const environment = { ...env, production, mode, context, apiEndpoint, demoCity, lang, geo, locale, tz, timezone, demoBypassAuth, demoAccount, demoPassword }
